import Vue from 'vue'
import VueRouter from 'vue-router'
import CheckStore from './middleware/check-store'
import CheckType from './middleware/check-type'
import CheckUrlId from './middleware/check-url-id'
import { store } from '@/store/index'

Vue.use(VueRouter)

const Reservation = () => import('./views/v1/reservation/Index').then(m => m.default || m)
const ReservationMenu = () => import('./views/v1/reservation/MenuGroupProduct').then(m => m.default || m)
const ReserveTime = () => import('./views/v1/reservation/ReserveTime').then(m => m.default || m)
const TakeAway = () => import('./views/v1/takeaway/Index').then(m => m.default || m)
const TakeAwayMenu = () => import('./views/v1/takeaway/MenuGroupProduct').then(m => m.default || m)
const TimeToTake = () => import('./views/v1/takeaway/TimeToTake').then(m => m.default || m)
const Delivery = () => import('./views/v1/delivery/Index').then(m => m.default || m)
const DeliveryMenu = () => import('./views/v1/delivery/MenuGroupProduct').then(m => m.default || m)
const DeliveryMethod = () => import('./views/v1/delivery/DeliveryMethod').then(m => m.default || m)
const DeliveryTime = () => import('./views/v1/delivery/DeliveryTime').then(m => m.default || m)
const DineIn = () => import('./views/v1/dinein/Index').then(m => m.default || m)
const DineInMenu = () => import('./views/v1/dinein/MenuGroupProduct').then(m => m.default || m)
const SelectTable = () => import('./views/v1/dinein/SelectTable').then(m => m.default || m)
const ScanQr = () => import('./views/v1/dinein/ScanQr').then(m => m.default || m)
const ScanQRCamera = () => import('./views/v1/dinein/ScanQRCamera').then(m => m.default || m)
const TotalGuest = () => import('./views/v1/dinein/TotalGuest').then(m => m.default || m)
const Login = () => import('./views/v1/auth/Login').then(m => m.default || m)
const LoginGuest = () => import('./views/v1/auth/LoginGuest').then(m => m.default || m)
const Register = () => import('./views/v1/auth/Register').then(m => m.default || m)
const SelectVerification = () => import('./views/v1/auth/SelectVerification').then(m => m.default || m)
const SelectOTPLogin = () => import('./views/v1/auth/SelectOTPLogin').then(m => m.default || m)
const RegisterSuccess = () => import('./views/v1/auth/RegisterSuccess').then(m => m.default || m)
const CallVerification = () => import('./views/v1/auth/CallVerification').then(m => m.default || m)
const CallVerificationLogin = () => import('./views/v1/auth/CallVerificationLogin').then(m => m.default || m)
const VerificationOTP = () => import('./views/v1/auth/VerificationOTP').then(m => m.default || m)
const VerificationOTPLogin = () => import('./views/v1/auth/VerificationOTPLogin').then(m => m.default || m)
const ForgetPassword = () => import('./views/v1/auth/ForgetPassword').then(m => m.default || m)
const ForgetVerificationOTP = () => import('./views/v1/auth/ForgetVerificationOTP').then(m => m.default || m)
const ForgetVerificationOTPsms = () => import('./views/v1/auth/ForgetVerificationOTPsms').then(m => m.default || m)
const NewPassword = () => import('./views/v1/auth/NewPassword').then(m => m.default || m)
const SetNewPassword = () => import('./views/v1/auth/SetNewPassword').then(m => m.default || m)
const Layout = () => import('./views/v1/layouts/Layout').then(m => m.default || m)
const Blank = () => import('./views/v1/layouts/Blank').then(m => m.default || m)
const Home = () => import('./views/v1/Home').then(m => m.default || m)
const ListOutlets = () => import('./views/v1/Outlets').then(m => m.default || m)
const Checkout = () => import('./views/v1/checkout/Checkout').then(m => m.default || m)
const SearchMap = () => import('./views/v1/maps/SearchMap').then(m => m.default || m)
const Payment = () => import('./views/v1/payment/Payment').then(m => m.default || m)
const OrderFailed = () => import('./views/v1/OrderFailed').then(m => m.default || m)
const OrderCancelled = () => import('./views/v1/OrderCancelled').then(m => m.default || m)
const OrderPaymentPending = () => import('./views/v1/OrderPaymentPending').then(m => m.default || m)
const OrderPaymentFailed = () => import('./views/v1/OrderPaymentFailed').then(m => m.default || m)
const OrderSuccess = () => import('./views/v1/OrderSuccess').then(m => m.default || m)
const VAOrder = () => import('./views/v1/VAOrder').then(m => m.default || m)
const Qris = () => import('./views/v1/Qris').then(m => m.default || m)
const CheckStatus = () => import('./views/v1/CheckStatus').then(m => m.default || m)
const Orders = () => import('./views/v1/order/Orders').then(m => m.default || m)
const Order = () => import('./views/v1/order/Order').then(m => m.default || m)
const Transactions = () => import('./views/v1/transaction/Transactions').then(m => m.default || m)
const Transaction = () => import('./views/v1/transaction/Transaction').then(m => m.default || m)
const Favorite = () => import('./views/v1/favorite/Index').then(m => m.default || m)
const LoyaltyPoint = () => import('./views/v1/LoyaltyPoint').then(m => m.default || m)
const Vouchers = () => import('./views/v1/voucher/Vouchers').then(m => m.default || m)
const ChangePassword = () => import('./views/v1/account/ChangePassword').then(m => m.default || m)
const ChangePhone = () => import('./views/v1/account/ChangePhone').then(m => m.default || m)
const ChangeEmail = () => import('./views/v1/account/ChangeEmail').then(m => m.default || m)
const ChangePhoneVerification = () => import('./views/v1/account/ChangePhoneVerification').then(m => m.default || m)
const ChangePhoneSMSVerification = () => import('./views/v1/account/ChangePhoneSMSVerification').then(m => m.default || m)
const QRCodeDineIn = () => import('./views/v1/qrcode/DineIn').then(m => m.default || m)
const QRCodeTakeAway = () => import('./views/v1/qrcode/TakeAway').then(m => m.default || m)
const QRCodeAstrapay = () => import('./views/v1/qrcode/Astrapay').then(m => m.default || m)
const LearnMore = () => import('./views/v1/LearnMore').then(m => m.default || m)
const StoreIsClose = () => import('./views/v1/StoreIsClose').then(m => m.default || m)
const NonActive = () => import('./views/v1/NonActive').then(m => m.default || m)
const RedirectSelectedType = () => import('./views/v1/RedirectSelectedType').then(m => m.default || m)
const TermsConditions = () => import('./views/v1/TermsConditions').then(m => m.default || m)
const PrivacyPolicy = () => import('./views/v1/PrivacyPolicy').then(m => m.default || m)
const IndexMenuBook = () => import('./views/v1/menubook/Index.vue').then(m => m.default || m)
const ListMenu = () => import('./views/v1/menubook/ListMenu.vue').then(m => m.default || m)
const DetailMenu = () => import('./views/v1/menubook/DetailMenu.vue').then(m => m.default || m)
const ReservationPlace = () => import('./views/v1/place-reservation/Index').then(m => m.default || m)
// new route
const _Layout = () => import('./views/v2/Layout').then(m => m.default || m)
const _Splash = () => import('./views/v2/Splash').then(m => m.default || m)
const _SplashDinein = () => import('./views/v2/SplashDinein').then(m => m.default || m)
const _QRCodeDineIn = () => import('./views/v2/qr/Dinein').then(m => m.default || m)
const _QRCodeTakeaway = () => import('./views/v2/qr/Takeaway').then(m => m.default || m)
const _Menu = () => import('./views/v2/Menu').then(m => m.default || m)
const _Checkout = () => import('./views/v2/Checkout').then(m => m.default || m)
const _Points = () => import('./views/v2/Points').then(m => m.default || m)
const _Vouchers = () => import('./views/v2/Vouchers').then(m => m.default || m)
const _Payment = () => import('./views/v2/Payment').then(m => m.default || m)
const _PhoneCheck = () => import('./views/v2/auth/PhoneCheck').then(m => m.default || m)
const _Verification = () => import('./views/v2/auth/Verification').then(m => m.default || m)
const _Account = () => import('./views/v2/auth/Account').then(m => m.default || m)
const _Qris = () => import('./views/v2/Qris').then(m => m.default || m)
const _RespOrder = () => import('./views/v2/RespOrder').then(m => m.default || m)
const _CheckPayment = () => import('./views/v2/CheckPayment').then(m => m.default || m)
const _LoyaltyPoint = () => import('./views/v2/LoyaltyPoint').then(m => m.default || m)
const _Orders = () => import('./views/v2/Orders').then(m => m.default || m)
const _Order = () => import('./views/v2/Order').then(m => m.default || m)
const _Transactions = () => import('./views/v2/Transactions').then(m => m.default || m)
const _Transaction = () => import('./views/v2/Transaction').then(m => m.default || m)
const _ChangeProfile = () => import('./views/v2/profile/ChangeProfile').then(m => m.default || m)
const _SelectOtp = () => import('./views/v2/profile/SelectOtp').then(m => m.default || m)
const _VerificationPhone = () => import('./views/v2/profile/VerificationPhone').then(m => m.default || m)
const _ChangePhone = () => import('./views/v2/profile/ChangePhone').then(m => m.default || m)
const _PrivacyPolicy = () => import('./views/v2/PrivacyPolicy').then(m => m.default || m)
const _MapsSearch = () => import('./views/v2/maps/Search').then(m => m.default || m)
const _MapsSelect = () => import('./views/v2/maps/Select').then(m => m.default || m)
const _DeliveryMethod = () => import('./views/v2/DeliveryMethod').then(m => m.default || m)
const _DeliveryTime = () => import('./views/v2/DeliveryTime').then(m => m.default || m)
const _ReservationDetail = () => import('./views/v2/ReservationDetail').then(m => m.default || m)
const _TableNotFound = () => import('./views/v2/TableNotFound').then(m => m.default || m)
const _StoreIsNotAvailable = () => import('./views/v2/StoreIsNotAvailable').then(m => m.default || m)

const routes = [
  {
    path: '/menu-book',
    name: 'menu_book',
    component: IndexMenuBook,
    redirect: { name: 'list_menu' },
    children: [
      { path: 'list', name: 'list_menu', component: ListMenu },
      { path: 'list/:product_type/:id', name: 'detail_menu', component: DetailMenu }
    ]
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: { name: 'home' },
    children: [
      {
        path: '/reservation',
        name: 'reservation',
        component: Blank,
        redirect: { name: 'reserve_time' },
        children: [
          { path: '/reservation/reserve-time', name: 'reserve_time', component: ReserveTime },
          { path: '/reservation/menu', name: 'reservation_menu', component: Reservation },
          { path: '/reservation/menu/group/:id', name: 'reservation_menu_group', component: ReservationMenu }
        ]
      },
      {
        path: '/take-away',
        name: 'take_away',
        component: Blank,
        redirect: { name: 'take_time' },
        children: [
          { path: '/take-away/time-to-take', name: 'take_time', component: TimeToTake },
          { path: '/take-away/menu', name: 'take_away_menu', component: TakeAway },
          { path: '/take-away/menu/group/:id', name: 'take_away_menu_group', component: TakeAwayMenu }
        ]
      },
      {
        path: '/delivery',
        name: 'delivery',
        component: Blank,
        redirect: { name: 'delivery_menu' },
        children: [
          { path: '/delivery/menu', name: 'delivery_menu', component: Delivery },
          { path: '/delivery/menu/group/:id', name: 'delivery_menu_group', component: DeliveryMenu },
          { path: '/delivery/select-method', name: 'delivery_method', component: DeliveryMethod },
          { path: '/delivery/time', name: 'delivery_time', component: DeliveryTime }
        ]
      },
      {
        path: '/dinein',
        name: 'dinein',
        component: Blank,
        redirect: { name: 'scan_qr_code' },
        children: [
          { path: '/dinein/scan-qrcode', name: 'scan_qr_code', component: ScanQr },
          { path: '/dinein/total-guest', name: 'total_guest_dinein', component: TotalGuest },
          { path: '/dinein/select-table', name: 'select_table', component: SelectTable },
          { path: '/dinein/menu', name: 'dinein_menu', component: DineIn },
          { path: '/dinein/qrcode-camera', name: 'qr_code_camera', component: ScanQRCamera },
          { path: '/dinein/menu/group/:id', name: 'dinein_menu_group', component: DineInMenu }
        ]
      },
      { path: '/login', name: 'login', component: Login },
      { path: '/login-as-guest', name: 'login_guest', component: LoginGuest },
      { path: '/register', name: 'register', component: Register },
      { path: '/register/success', name: 'register_success', component: RegisterSuccess },
      { path: '/select-verification', name: 'select_verification', component: SelectVerification },
      { path: '/select-otp-login', name: 'select_otp_login', component: SelectOTPLogin },
      { path: '/call-verification', name: 'call_verification', component: CallVerification },
      { path: '/call-verification-login', name: 'call_verification_login', component: CallVerificationLogin },
      { path: '/verification', name: 'verification_otp', component: VerificationOTP },
      { path: '/verification-login', name: 'verification_otp_login', component: VerificationOTPLogin },
      { path: '/forget-password', name: 'forget_password', component: ForgetPassword },
      { path: '/forget-password/verification', name: 'forget_verification_otp', component: ForgetVerificationOTP },
      { path: '/forget-password/verification-sms', name: 'forget_verification_otp_sms', component: ForgetVerificationOTPsms },
      { path: '/forget-password/new-password', name: 'new_password', component: NewPassword },
      { path: '/set-new-password', name: 'set_new_password', component: SetNewPassword },
      { path: '/home', name: 'home', component: Home },
      { path: '/list-outlets', name: 'listoutlets', component: ListOutlets },
      { path: '/checkout', name: 'checkout', component: Checkout },
      { path: '/checkout/payment', name: 'payment', component: Payment },
      { path: '/checkout/payment/check', name: 'check_status', component: CheckStatus },
      { path: '/checkout/payment/failed', name: 'order_failed', component: OrderFailed },
      { path: '/checkout/payment/cancelled', name: 'order_cancelled', component: OrderCancelled },
      { path: '/checkout/payment/payment-pending', name: 'order_payment_pending', component: OrderPaymentPending },
      { path: '/checkout/payment/payment-failed', name: 'order_payment_failed', component: OrderPaymentFailed },
      { path: '/checkout/payment/success', name: 'order_success', component: OrderSuccess },
      { path: '/checkout/payment/virtual-account', name: 'va_order', component: VAOrder },
      { path: '/checkout/payment/qris', name: 'qris', component: Qris },
      {
        path: '/account',
        name: 'account_layout',
        component: Blank,
        children: [
          { path: '/change-password', name: 'change_password', component: ChangePassword },
          { path: '/change-phone', name: 'change_phone', component: ChangePhone },
          { path: '/change-email', name: 'change_email', component: ChangeEmail },
          { path: '/phone-verification', name: 'chenge_phone_verification', component: ChangePhoneVerification },
          { path: '/sms-verification', name: 'chenge_phone_sms_verification', component: ChangePhoneSMSVerification },
          { path: '/order', name: 'orders', component: Orders },
          { path: '/order/:id', name: 'order', component: Order },
          { path: '/transaction', name: 'transactions', component: Transactions },
          { path: '/transaction/:id', name: 'transaction', component: Transaction },
          { path: '/favorite', name: 'favorite', component: Favorite },
          { path: '/loyalty-point', name: 'loyalty_point', component: LoyaltyPoint },
          { path: '/voucher', name: 'vouchers', component: Vouchers }
        ]
      },
      { path: '/qrcode-dinein/:url_id/:store_id/:no_table', name: 'qrcode_dinein', component: QRCodeDineIn },
      { path: '/qrcode-takeaway/:url_id/:store_id', name: 'qrcode_takeaway', component: QRCodeTakeAway },
      { path: '/qrcode-astrapay', name: 'qrcode_astrapay', component: QRCodeAstrapay },
      { path: '/learn-more', name: 'learn_more', component: LearnMore },
      { path: '/maps/search', name: 'search_map', component: SearchMap },
      { path: '/close', name: 'store_is_close', component: StoreIsClose },
      { path: '/non-active', name: 'non_active', component: NonActive },
      { path: '/redirect/:selected_type', name: 'redirect_selected_type', component: RedirectSelectedType },
      { path: '/terms-conditions', name: 'terms_conditions', component: TermsConditions },
      { path: '/privacy-policy', name: 'privacy_policy', component: PrivacyPolicy },
      {
        path: '/reservation-place',
        name: 'reservation_place',
        component: ReservationPlace
      }
    ]
  },
  // new route
  {
    path: '/v2/',
    name: '_layout',
    component: _Layout,
    redirect: { name: '_splash' },
    children: [
      { path: '/v2/welcome', name: '_splash', component: _Splash },
      { path: '/v2/dinein-welcome', name: '_splash_dinein', component: _SplashDinein },
      { path: '/v2/qrcode-dinein/:url_id/:store_id/:no_table', name: '_qrcode_dinein', component: _QRCodeDineIn },
      { path: '/v2/qrcode-takeaway/:url_id/:store_id', name: '_qrcode_takeaway', component: _QRCodeTakeaway },
      { path: '/v2/menu', name: '_menu', component: _Menu },
      { path: '/v2/checkout', name: '_checkout', component: _Checkout },
      { path: '/v2/checkout/point', name: '_points', component: _Points },
      { path: '/v2/checkout/voucher', name: '_vouchers', component: _Vouchers },
      { path: '/v2/checkout/payment', name: '_payment', component: _Payment },
      { path: '/v2/checkout/payment/qris/:id', name: '_qris', component: _Qris },
      { path: '/v2/checkout/payment/order/:id', name: '_resp_order', component: _RespOrder },
      { path: '/v2/checkout/payment/check', name: '_check_payment', component: _CheckPayment },
      { path: '/v2/auth/phone-check', name: '_phone_check', component: _PhoneCheck },
      { path: '/v2/auth/verification', name: '_verification', component: _Verification },
      { path: '/v2/auth/account', name: '_account', component: _Account },
      { path: '/v2/account/order', name: '_orders', component: _Orders },
      { path: '/v2/account/order/:id', name: '_order', component: _Order },
      { path: '/v2/account/loyalty-point', name: '_loyalty_point', component: _LoyaltyPoint },
      { path: '/v2/account/transaction', name: '_transactions', component: _Transactions },
      { path: '/v2/account/transaction/:id', name: '_transaction', component: _Transaction },
      { path: '/v2/account/profile', name: '_change_profile', component: _ChangeProfile },
      { path: '/v2/account/select-otp', name: '_select_otp', component: _SelectOtp },
      { path: '/v2/account/verify-phone', name: '_verification_phone', component: _VerificationPhone },
      { path: '/v2/account/change-phone', name: '_change_phone', component: _ChangePhone },
      { path: '/v2/privacy-policy', name: '_privacy_policy', component: _PrivacyPolicy },
      { path: '/v2/maps/search', name: '_maps_search', component: _MapsSearch },
      { path: '/v2/maps/select', name: '_maps_select', component: _MapsSelect },
      { path: '/v2/delivery/method', name: '_delivery_method', component: _DeliveryMethod },
      { path: '/v2/delivery/time', name: '_delivery_time', component: _DeliveryTime },
      { path: '/v2/reservation', name: '_reservation_detail', component: _ReservationDetail },
      { path: '/v2/table-not-found', name: '_table_not_found', component: _TableNotFound }
    ]
  },
  { path: '/v2/store-not-available', name: '_store_is_not_available', component: _StoreIsNotAvailable }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const whiteList = [
  'home',
  'listoutlets',
  'reservation',
  'reserve_time',
  'reservation_menu',
  'reservation_menu_group',
  'take_away',
  'take_time',
  'take_away_menu',
  'take_away_menu_group',
  'delivery',
  'delivery_menu',
  'delivery_menu_group',
  'delivery_method',
  'delivery_time',
  'dinein',
  'dinein_menu',
  'dinein_menu_group',
  'select_table',
  'scan_qr_code',
  'qr_code_camera',
  'total_guest_dinein',
  'checkout',
  'payment',
  'check_status',
  'order_failed',
  'order_cancelled',
  'order_payment_pending',
  'order_payment_failed',
  'order_success',
  'va_order',
  'qris',
  'reservation_place',
  // new route
  '_splash',
  '_splash_dinein',
  '_menu',
  '_checkout',
  '_points',
  '_vouchers',
  '_payment',
  '_account',
  '_qris',
  '_resp_order',
  '_maps_search',
  '_maps_select',
  '_delivery_method',
  '_delivery_time',
  '_reservation_detail'
]

const publicList = [
  'redirect_selected_type',
  'qrcode_dinein',
  'qrcode_takeaway',
  'qrcode_astrapay',
  'learn_more',
  'search_map',
  'store_is_close',
  'non_active',
  'terms_conditions',
  'privacy_policy',
  // new route
  '_qrcode_dinein',
  '_qrcode_takeaway',
  '_privacy_policy',
  '_table_not_found',
  '_store_is_not_available'
]

const authlink = [
  'login',
  'login_guest',
  'register',
  'select_verification',
  'select_otp_login',
  'call_verification',
  'call_verification_login',
  'verification_otp',
  'verification_otp_login',
  'forget_password',
  'forget_verification_otp',
  'forget_verification_otp_sms',
  'new_password',
  'set_new_password',
  // new route
  '_phone_check',
  '_verification'
]

const menubook = [
  'menu_book',
  'list_menu',
  'detail_menu'
]

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}

router.beforeEach(async(to, from, next) => {
  if (to.path === '/reservation-place') {
    const vuetifyStylesheet = document.createElement('link')
    vuetifyStylesheet.rel = 'stylesheet'
    vuetifyStylesheet.href = 'https://cdn.jsdelivr.net/npm/vuetify@2.1.7/dist/vuetify.min.css'
    document.head.appendChild(vuetifyStylesheet)
  }

  store.state.loading = true
  const storeIsAvailable = await store.dispatch('checkDomain')

  if (!storeIsAvailable && to.name !== '_store_is_not_available') {
    next({ name: '_store_is_not_available' })
  } else {
    if (to.name === '_store_is_not_available') {
      next()
    } else {
      await CheckStore(to, from, next)
      const auth_data = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))
      // store is active
      if (!isEmpty(store.state.selected_store)) {
        if (store.state.selected_store.setting.is_active === 0) {
          if (to.name !== 'non_active') {
            next({ name: 'non_active' })
            store.state.loading = false
          } else {
            next()
          }
        } else {
          if (auth_data !== null) {
            if (auth_data.auth_by === 'BASIC') {
              // if auth true
              if (authlink.indexOf(to.name) !== -1) {
                if (to.query.redirect) {
                  next({ name: to.query.redirect })
                } else {
                  const astra_outlet = store.state.store_astra
                  const tmii_outlet = store.state.store_tmii
                  const url_id = store.state.url_domain

                  if (tmii_outlet.indexOf(url_id) !== -1) {
                    window.location.href = 'https://order.kulinertmii.id'
                  } else if (astra_outlet.indexOf(url_id) !== -1) {
                    window.location.href = 'https://zestloungemenaraastra.myolsera.com'
                  } else {
                    next({ name: 'home' })
                  }
                }
              } else {
                // if whiteList true
                if (whiteList.indexOf(to.name) !== -1) {
                  CheckUrlId(to, from, next)
                  CheckType(to, from, next)
                  next()
                } else if (menubook.indexOf(to.name) !== -1) {
                  if (store.state.selected_store.plan_type_id !== 'L') {
                    if (store.state.selected_store.setting.active_book_menu) {
                      next()
                    } else {
                      next({ name: 'non_active' })
                    }
                  } else {
                    next({ name: 'non_active' })
                  }
                } else {
                  next()
                }
              }
            } else if (auth_data.auth_by === 'GUEST') {
              if (authlink.indexOf(to.name) !== -1) {
                next()
              } else {
                if (whiteList.indexOf(to.name) !== -1) {
                  CheckUrlId(to, from, next)
                  CheckType(to, from, next)
                  next()
                } else if (menubook.indexOf(to.name) !== -1) {
                  if (store.state.selected_store.plan_type_id !== 'L') {
                    if (store.state.selected_store.setting.active_book_menu) {
                      next()
                    } else {
                      next({ name: 'non_active' })
                    }
                  } else {
                    next({ name: 'non_active' })
                  }
                } else {
                  next()
                }
              }
            } else {
              // if auth true
              if (authlink.indexOf(to.name) !== -1) {
                next()
              } else {
                // if whiteList true
                if (publicList.indexOf(to.name) !== -1) {
                  next()
                } else if (whiteList.indexOf(to.name) !== -1) {
                  CheckUrlId(to, from, next)
                  CheckType(to, from, next)
                  next()
                } else if (menubook.indexOf(to.name) !== -1) {
                  if (store.state.selected_store.plan_type_id !== 'L') {
                    if (store.state.selected_store.setting.active_book_menu) {
                      next()
                    } else {
                      next({ name: 'non_active' })
                    }
                  } else {
                    next({ name: 'non_active' })
                  }
                } else {
                  if (isEmpty(to.params)) {
                    if ((to.name === 'orders' || to.name === '_orders') && store.state.selected_store.setting.no_auth_dinein === 1) {
                      next()
                    } else if (to.name === 'reservation_place' && to.query.date) {
                      next({ name: 'login', query: { redirect: to.name, date: to.query.date }})
                    } else {
                      next({ name: 'login', query: { redirect: to.name }})
                    }
                  } else {
                    if (to.name === 'order' || to.name === '_order') {
                      if (store.state.selected_store.setting.no_auth_dinein === 1) {
                        next()
                      } else if (to.name === '_order') {
                        next({ name: '_phone_check', query: { redirect: 'order', id: to.params.id }})
                      } else {
                        next({ name: 'login', query: { redirect: 'order', id: to.params.id }})
                      }
                    } else {
                      next({ name: 'login', query: { redirect: 'home' }})
                    }
                  }
                }
              }
            }
          } else {
            next()
          }
        }
      } else if (to.name !== '_store_is_not_available') {
        next({ name: '_store_is_not_available' })
      } else {
        next()
      }
    }
  }
})

router.afterEach((to, from) => {
  store.state.router_from = from
  setTimeout(function() { store.state.loading = false }, 1000)
})

export default router
